import {
  DataObjectId,
  Hub,
  noBoardContainerId,
  Subtask,
  taskTemplatesContainerId
} from 'yougile-model'
import {Sync} from '@client/sync'
import {refreshStickers} from './refresh-stickers'

export const recreateSubtasks = (newTask: Hub): void => {
  const box = Sync.getCurrentSandbox()
  const companyId = box.companyId

  const subtasksList = newTask.data?.subtaskList
  if (!subtasksList) {
    return
  }

  const output: Hub[] = []

  const subtasks = Object.values(subtasksList.subtasks)

  const subtasksAcc = {} as Record<string, Subtask>

  for (const subtask of subtasks) {
    const oldSubtaskId = subtask.id

    if (subtask.isDeleted) {
      continue
    }

    if (
      subtask.location !== noBoardContainerId &&
      subtask.location !== taskTemplatesContainerId
    ) {
      subtasksAcc[oldSubtaskId] = subtask
      continue
    }

    const subtaskHubOld = box.getHub(oldSubtaskId)

    if (!subtaskHubOld) {
      continue
    }

    const json = subtaskHubOld.toJSON()

    const subtaskHub = new Hub(companyId, '')
    subtaskHub.fromJSON(box.companyId, json)
    subtaskHub.location = noBoardContainerId

    subtaskHub.data.subtaskList = {subtasks: {}, order: []}
    subtaskHub.data.by = newTask.data.by

    clearHub({task: subtaskHub, key: 'id', companyId})
    clearHub({task: subtaskHub, key: 'timestamp', companyId})
    clearHub({task: subtaskHub, key: 'chat', companyId})

    refreshStickers(subtaskHub)

    subtaskHub.commit()

    const newSubtaskId = subtaskHub.id

    const orderIdx = subtasksList.order.findIndex(item => item === oldSubtaskId)
    subtasksList.order[orderIdx] = newSubtaskId

    subtask.id = newSubtaskId
    subtask.isCompleted = false
    subtask.isArchived = undefined

    output.push(subtaskHub)

    subtasksAcc[newSubtaskId] = subtask
  }

  subtasksList.subtasks = subtasksAcc

  for (const t of output) {
    box.add(t, t.location, true, false)
  }
}

interface ClearProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  task: any // HubJSON
  key: keyof Hub
  companyId: DataObjectId
}

export const clearHub = (props: ClearProps): void => {
  const {task, key, companyId} = props
  task[key] = new Hub(companyId, '')[key]
}
